export default (editmode = false, isOpen = false) => ({
  isOpen,
  editmode,

  toggle() {
    if (this.editmode) return

    this.isOpen = !this.isOpen
  },
})